import Phaser from 'phaser';
import WebFont from 'utils/webfontloader';
import { STATE_WELCOME, FONT_COPY, FONT_TITLE, LOCATIONS } from '../constants/AppConstants';
import GameController from '../controller/GameController';
import PollController, { GetPollData } from '../controller/PollController';
import ScreenContainer from '../display/ui/ScreenContainer';
import LoadDisplay from '../display/ui/LoadDisplay';

export default class extends Phaser.State {
  preload() {
    // store everything in a container, it will reposition for screen
    this.container = new ScreenContainer(this.game, {
      background: 'background_generic',
      overlay: true,
    });
    this.game.add.existing(this.container);

    this.loadDisplay = new LoadDisplay(this.game, true, true, '');
    this.loadDisplay.x = this.game.defaultWidth * 0.5 - this.loadDisplay.width * 0.5;
    this.loadDisplay.y = this.game.defaultHeight * 0.5 - this.loadDisplay.height * 0.5;
    this.container.add(this.loadDisplay);

    this.copy = this.game.make.text(this.game.width / 2, 100, '', {
      font: '18px ' + this.game.titleFontStyle,
      fill: '#FFFFFF',
    });
    this.container.add(this.copy);

    this.loadComplete = false;

    this.fontsReady = false;
    this.assetsReady = false;

    // GetPollData();

    this.loadFonts();
    this.loadAppAssetPacks();
  }

  loadFonts() {
    WebFont.load({
      custom: {
        families: [FONT_COPY, FONT_TITLE],
        urls: ['assets/fonts/fonts.css'],
      },
      active: this.fontsLoaded.bind(this),
      inactive: this.fontsLoaded.bind(this),
    });
  }

  loadAppAssetPacks() {
    this.game.load.baseURL = './assets/';
    this.game.load.crossOrigin = 'anonymous';
    this.game.load.pack('load', 'assetpack.json', null, this);
    this.game.load.pack('ui', 'assetpack.json', null, this);
    this.game.load.pack('suitcase', 'assetpack.json', null, this);
    this.game.load.onFileComplete.add(this.fileComplete, this);

    if (this.game.device.touch) {
      this.game.load.pack('tutorial_touch', 'assetpack.json', null, this);
    } else {
      this.game.load.pack('tutorial_desktop', 'assetpack.json', null, this);
    }

    // adding the poll images here so I can loop :)
    this.game.load.pack('poll', null, {
      poll: LOCATIONS.reduce((arr, loc) => {
        let i = 3;
        while (i > 0) {
          arr.push({
            type: 'image',
            key: 'poll_' + loc.toLowerCase() + '_' + i,
            url: 'locations/' + loc.toLowerCase() + '/poll/poll_' + i + '.png',
          });
          i--;
        }
        return arr;
      }, []),
    });
  }

  fileComplete(progress, cacheKey, success, totalLoaded, totalFiles) {
    this.loadDisplay.progress = progress;
  }

  loadUpdate() {}

  create() {
    this.assetsReady = true;
    this.game.sounds.touchLock();
    this.game.windowEventController.handleWindowResize();

    // Create new game controller
    this.game.gameController = new GameController(this.game);
    this.game.pollController = new PollController();
  }

  fontsLoaded() {
    this.fontsReady = true;
    this.checkLoading();
  }

  update() {
    this.checkLoading();
  }

  checkLoading() {
    if (!this.loadComplete && this.assetsReady && this.fontsReady) {
      if (this.game.sounds.soundsAreDecoded()) {
        this.game.sounds.checkAudioContext();
        this.handleLoadComplete();
      }
    }
  }

  handleLoadComplete() {
    if (!this.loadComplete) {
      this.loadComplete = true;
      this.game.app_config = this.game.cache.getJSON('app_config');
      this.game.ui_config = this.game.cache.getJSON('ui_config');

      // register audio
      for (let i in this.game.app_config.audio) {
        this.game.sounds.addSound(this.game.app_config.audio[i], this.game.app_config.audio[i]);
      }
      for (let i in this.game.app_config.audiosprite) {
        this.game.sounds.addAudioSprite({ id: this.game.app_config.audiosprite[i] });
      }

      // go to welcome screen
      this.game.state.start(STATE_WELCOME, true, false);
    }
  }

  shutdown() {
    this.game.load.onFileComplete.remove(this.fileComplete, this);
    this.loadDisplay.destroy();
    this.loadDisplay = null;

    this.container.destroy();
    this.container = null;
  }
}



// WEBPACK FOOTER //
// ./js/app/states/Load.js